import { HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { ServerMsgResponse } from '@domain/entities/general.model';
import {
    ProfessionalModel,
    ProfessionalServerModel,
} from '@domain/entities/professional.model';
import { GeneralResponse } from '@domain/entities/general.model';
export abstract class ProfessionalGateway {
    abstract create(form: ProfessionalModel): Observable<ServerMsgResponse>;
    abstract update(form: ProfessionalModel): Observable<ServerMsgResponse>;
    abstract read(
        params?: HttpParams
    ): Observable<GeneralResponse<ProfessionalServerModel>>;
    abstract delete(id: string): Observable<ServerMsgResponse>;
    abstract createPhone(
        idProfesional: string,
        phone: string
    ): Observable<ServerMsgResponse>;
    abstract deletePhone(
        idProfesional: string,
        phone: string
    ): Observable<ServerMsgResponse>;
    abstract readById(id: string): Observable<ProfessionalServerModel>;
    abstract updateStudy(form: any): Observable<ServerMsgResponse>;
    abstract getPhoto(id: string): Observable<Blob>;
    abstract updatePhoto(form: FormData): Observable<Blob>;
    abstract laborAspect(form: any): Observable<ServerMsgResponse>;
    abstract getLaborAspect(id: string): Observable<any>;
}
